import { Modal, ModalBody, ModalButton, ModalFooter, ModalHeader, ROLE, SIZE } from 'baseui/modal'
import React from 'react'

const ValidationModal: React.FC<{
    show: boolean
    error_text: string
    handleCloseValidationModal: () => void
}> = (props) => {
    return (
        <div>
            <Modal
                onClose={props.handleCloseValidationModal}
                closeable
                //TODO check
                //@ts-ignore
                unstable_ModalBackdropScroll={true}
                isOpen={props.show}
                animate
                autoFocus
                size={SIZE.default}
                role={ROLE.dialog}
            >
                <ModalHeader>Polygon Validation Error</ModalHeader>
                <ModalBody>{props.error_text}</ModalBody>
                <ModalFooter>
                    <ModalButton onClick={props.handleCloseValidationModal}>Okay</ModalButton>
                </ModalFooter>
            </Modal>
        </div>
    )
}
export default ValidationModal
